import Model from 'core/model/Model';
import { computed } from 'mobx';

class KentikAgentClusterModel extends Model {
  get urlRoot() {
    return '/api/ui/kentik-agent/clusters';
  }

  @computed
  get name() {
    return this.get('cluster.displayName');
  }

  @computed
  get clusterId() {
    return this.get('cluster.clusterId');
  }

  @computed
  get healthState() {
    return this.get('healthState');
  }

  @computed
  get agents() {
    return this.get('agents') || [];
  }

  @computed
  get groups() {
    return this.get('groups') || [];
  }
}

export default KentikAgentClusterModel;
